import React from 'react'
import { ContentInformation, ComponentInformationColumn } from './styles'
import { FooterLabels } from 'src/types'
import { LineHeight25 } from 'src/components/common/Typography/typography'
import { MapColumn } from './MapColumn'
export function MapInformation({ title, component }: FooterLabels) {
    return (
        <ContentInformation paddingTop={'titlle'} paddingBottom={'xlarge'}>
            <LineHeight25 variant={'h2'} fontSize={'xxxsmall'} fontWeight={600}>
                {title}
            </LineHeight25>
            <ComponentInformationColumn paddingTop={'medium'}>
                {component.map((column) => {
                    return <MapColumn key={column.id} {...column} />
                })}
            </ComponentInformationColumn>
        </ContentInformation>
    )
}
